import { Avatar, Box, HStack, Text, VStack } from '@chakra-ui/react';
import { FiChevronDown } from 'react-icons/fi';

export default function Header() {
  return (
    <>
      <HStack>
        <Avatar size={'sm'} src={'/assets/images/team/aubin.jpg'} />
        <VStack
          display={{ base: 'none', md: 'flex' }}
          alignItems="flex-start"
          spacing="1px"
          ml="2"
        >
          <Text fontSize="sm">Aubin KENG...</Text>
          <Text fontSize="xs" color="gray.600">
            Admin
          </Text>
        </VStack>
        <Box display={{ base: 'none', md: 'flex' }}>
          <FiChevronDown />
        </Box>
      </HStack>
    </>
  );
}
